var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live",staticStyle:{"display":"block"}},[_c('iframe',{staticClass:"iframe",staticStyle:{"border":"0"},attrs:{"id":"myIframe","src":_vm.link,"frameborder":"0","scrolling":"no","allowfullscreen":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }